// src/vdr/providers.ts

/** ---------- Provider IDs ---------- */
export const VDR_PROVIDER_IDS = [
  "none",
  "basic",
  "dataroom",
  "intralinks",
  "firmex",
  "ideals",
  "sterling",
  "requestlist",
  "netdocuments",
  "imanage",
  "sharefile",
  "box",
  "sharepoint",
] as const;

export type VDRProviderId = typeof VDR_PROVIDER_IDS[number];

/** ---------- Normalized index row (output of any parser) ---------- */
export type IndexRow = {
  /** e.g., "1", "1.1", "1.1.2" */
  code: string;
  /** human-readable title for the section */
  title: string;
  /** optional path hint (e.g., folder chain like "01 Corporate/01.01 Charters") */
  pathHint?: string;
  /** provider-specific extras if needed */
  meta?: Record<string, unknown>;
};

/** ---------- Provider registry (UI uses this) ---------- */
export interface ProviderMeta {
  id: VDRProviderId;
  label: string;
}

export const VDR_PROVIDERS: ProviderMeta[] = [
  { id: "none",         label: "-- Select VDR provider --" },
  { id: "basic",        label: "Basic (XLSX / simple)" },
  { id: "dataroom",     label: "Datasite" },
  { id: "intralinks",   label: "Intralinks" },
  { id: "firmex",       label: "Firmex" },
  { id: "ideals",       label: "IdealsVDR" },
  { id: "sterling",    label: "Sterling" },
  { id: "requestlist", label: "Kourtney" }, // placeholder name until we know the VDR
  { id: "netdocuments", label: "NetDocuments (coming soon)" },
  { id: "imanage",      label: "iManage (coming soon)" },
  { id: "sharefile",    label: "ShareFile (coming soon)" },
  { id: "box",          label: "Box (coming soon)" },
  { id: "sharepoint",   label: "SharePoint (coming soon)" },
];
